module.exports = __webpack_public_path__ + "img/esquemaC.046e1733.svg";